const categories = [ "ساعات", "سماعات", "مشط حراري", "فوم تنظيف" ];

export default categories;